import type { FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import Badge from '@segment/matcha/components/Badge'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import CardBase, * as Card from '@segment/matcha/recipes/Card'

import TheCustomerDataPlatformReport2021Png from './assets/TheCustomerDataPlatformReport2021.png'
import WaysToUseDataToEngageYourCustomersPng from './assets/WaysToUseDataToEngageYourCustomers.png'
import Personalization102AdvancedGuideToPersonalizationPng from './assets/Personalization102AdvancedGuideToPersonalization.png'

const data = [
  {
    image: TheCustomerDataPlatformReport2021Png,
    badge: `Report`,
    title: `The Customer Data Platform Report 2021`,
    description: `We analyzed ten trillion data points to find out how the Customer Data Platform market is evolving.`,
    button: `Download the report`,
    url: `https://learn.segment.com/customer-data-platform-report-2021/`,
  },
  {
    image: WaysToUseDataToEngageYourCustomersPng,
    badge: `Guide`,
    title: `15 Ways to Use Data to Engage Your Customers`,
    description: `This guide shares 15 different ways you can use Segment and Twilio to make your customer engagement more intelligent across every channel.`,
    button: `Download the guide`,
    url: `https://learn.segment.com/15-ways-to-use-data/`,
  },
  {
    image: Personalization102AdvancedGuideToPersonalizationPng,
    badge: `Guide`,
    title: `Personalization 102: Advanced Guide to Personalization`,
    description: `This guide goes beyond fluffy best practices to help you up-level your efforts with personalization.`,
    button: `Download the guide`,
    url: `https://learn.segment.com/advanced-personalization-guide/`,
  },
]
const HEADING = `Recommended reading`
const RecommendedReading: FC = () => {
  return (
    <StyledSection variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3" variant="h2">
            {HEADING}
          </CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack
          overrides={{
            md: 3,
          }}
        >
          {data.map(({ image, badge, title, description, button, url }, key) => (
            <CardBase key={key} href={url}>
              <StyledCardImage alt={`Illustration: ${title}`} src={image} variant="fill" />
              <Card.Body>
                <Card.Accessories>
                  <Card.AccessoriesRow>
                    <Badge variant="outlined">{badge}</Badge>
                  </Card.AccessoriesRow>
                </Card.Accessories>
                <Card.Copy>
                  <Card.Headline>{title}</Card.Headline>
                  <Card.Description>{description}</Card.Description>
                </Card.Copy>
                <Card.Action alignment="left">
                  <ButtonText iconEnd={ChevronRightIcon}>{button}</ButtonText>
                </Card.Action>
              </Card.Body>
            </CardBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 40px;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      row-gap: 80px;
    }
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  margin: 0 auto;
  max-width: 1120px;
`

const StyledCardImage = styled(Card.Image)`
  height: 198px;
`

export default RecommendedReading
